import '../../App.scss';
import '../../css/modals.scss';
import React, { useState, useEffect, useContext, createRef } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import BaseModal from './BaseModal';
import BaseForm from '../BaseForm';
import SubmitButton from '../SubmitButton';
import { Row, Col } from 'react-bootstrap';
import StripeSetupPaymentMethod from '../StripeSetupPaymentMethod';
import { BaseContext } from '../../helpers/common';
import { useTranslation } from 'react-i18next';
const _ = require('lodash');

function SetupPaymentMethodModal(props) {
    const { t } = useTranslation('common');
    const { settings } = useContext(BaseContext)
    const setupRef = createRef();

    const renderPaymentProviderNotSetup = () => {
        return (
            <BaseModal {...props}>
                <BaseModal.Header>
                    <BaseModal.Title>Payment Provider not setup</BaseModal.Title>
                </BaseModal.Header>
                <BaseModal.Body>
                    <p>No payment provider has been setup for your company. Please connect your existing payment provider to manage group's payment methods.</p>
                </BaseModal.Body>
            </BaseModal>
        )
    }

    const renderPaymentProviderNotSupported = () => {
        return (
            <BaseModal {...props}>
                <BaseModal.Header>
                    <BaseModal.Title>{t('common.edit')} Provider not supported</BaseModal.Title>
                </BaseModal.Header>
                <BaseModal.Body>
                    The provider { settings.paymentProcessor } is not supported. Please contact your company admin.
                </BaseModal.Body>
                <BaseModal.Footer>
                </BaseModal.Footer>
            </BaseModal>
        )
    }

    const onSubmit = async (data) => {
        if (setupRef.current) {
            await setupRef.current.onSubmit(data);
        }
    }
    const redirectUrl = window.location.href;

    if (!props.show) {
        return null;
    }

    if (_.isNil(settings.paymentProcessor) || _.isNil(settings.paymentProcessor)) {
        return renderPaymentProviderNotSetup();
    } else {
        const isPaymentProviderSupported = settings.paymentProcessor === "STRIPE"
        if (!isPaymentProviderSupported) {
            return renderPaymentProviderNotSupported()
        } else {
            return (
                <BaseModal {...props}>
                    <BaseModal.Header>
                        <BaseModal.Title>{t('payment_methods.add.title')}</BaseModal.Title>
                    </BaseModal.Header>
                    <BaseForm onSubmit={onSubmit}>
                        <BaseModal.Body>
                            <div className="body1">
                                Add payment method to { props.group.groupName }
                            </div>
                            <div className="payment_input">
                            {
                                settings.paymentProcessor === "STRIPE" &&
                                    <StripeSetupPaymentMethod ref={setupRef} {...props} redirectUrl={redirectUrl} />
                            }
                            </div>
                        </BaseModal.Body>
                        <BaseModal.Footer>
                            <Row>
                                <Col md="12" className="text-end">
                                    <SubmitButton variant="primary">{t('payment_methods.add.action')}</SubmitButton>
                                </Col>
                            </Row>
                        </BaseModal.Footer>
                    </BaseForm>
                </BaseModal>
            );
        }
    }
}

export default SetupPaymentMethodModal;
